import DIALOG_DEFAULT_HEIGHTS from '@/components/base_components/dialog/components/enums/DIALOG_DEFAULT_HEIGHTS';
import DIALOG_DEFAULT_WIDTHS from '@/components/base_components/dialog/components/enums/DIALOG_DEFAULT_WIDTHS';

export default {
  data() {
    return {
      remainingHeight: '100',
    };
  },
  computed: {
    currentMaxHeight() {

      if (this.$vuetify.breakpoint.lgAndUp) {
        return this.vhInPixel(DIALOG_DEFAULT_HEIGHTS.LARGE_AND_UP[this.height]);
      }

      if (this.$vuetify.breakpoint.mdOnly) {
        return this.vhInPixel(DIALOG_DEFAULT_HEIGHTS.MEDIUM[this.height]);
      }

      if (this.$vuetify.breakpoint.smOnly) {
        return this.vhInPixel(DIALOG_DEFAULT_HEIGHTS.SMALL[this.height]);
      }

      return this.vhInPixel(DIALOG_DEFAULT_HEIGHTS.EXTRA_SMALL);
    },
    currentMaxWidth() {

      if (this.$vuetify.breakpoint.lgAndUp) {
        return this.vwInPixel(DIALOG_DEFAULT_WIDTHS.LARGE_AND_UP[this.width]);
      }

      if (this.$vuetify.breakpoint.mdOnly) {
        return this.vwInPixel(DIALOG_DEFAULT_WIDTHS.MEDIUM[this.width]);
      }

      if (this.$vuetify.breakpoint.smOnly) {
        return this.vwInPixel(DIALOG_DEFAULT_WIDTHS.SMALL[this.width]);
      }

      return this.vwInPixel(DIALOG_DEFAULT_WIDTHS.EXTRA_SMALL);
    }
  },
  methods: {
    vhInPixel(vh) {
      return document.documentElement.clientHeight * (vh / 100);
    },
    vwInPixel(vw) {
      return document.documentElement.clientWidth * (vw / 100);
    },
  }
}
